export default "__VITE_ASSET__BjQ5$sYI__"